import {chunk} from 'lodash';
const product = [{
	'product_id': 1,
	'product_name': 'Redmi K30',
	'category_id': 1,
	'product_title': '120Hz流速屏，全速热爱',
	'product_intro': '120Hz高帧率流速屏/ 索尼6400万前后六摄 / 6.67\'小孔径全面屏 / 最高可选8GB+256GB大存储 / 高通骁龙730G处理器 / 3D四曲面玻璃机身 / 4500mAh+27W快充 / 多功能NFC',
	'product_picture': 'https://cdn.cnbj1.fds.api.mi-img.com/mi-mall/b3553083a4975325eab6470d94465548.jpg?thumb=1&w=400&h=400&f=webp&q=90',
	'product_price': 2000,
	'product_selling_price': 1599,
	'product_num': 10,
	'product_sales': 0,
}, {
	'product_id': 2,
	'product_name': 'Redmi K30 5G',
	'category_id': 1,
	'product_title': '双模5G,120Hz流速屏',
	'product_intro': '双模5G / 三路并发 / 高通骁龙765G / 7nm 5G低功耗处理器 / 120Hz高帧率流速屏 / 6.67\'小孔径全面屏 / 索尼6400万前后六摄 / 最高可选8GB+256GB大存储 / 4500mAh+30W快充 / 3D四曲面玻璃机身 / 多功能NFC',
	'product_picture': 'https://cdn.cnbj1.fds.api.mi-img.com/mi-mall/68217751d12b1bfd2f9766e458b5e2dd.jpg?thumb=1&w=400&h=400&f=webp&q=90',
	'product_price': 2599,
	'product_selling_price': 2599,
	'product_num': 10,
	'product_sales': 0,
}, {
	'product_id': 3,
	'product_name': '小米CC9 Pro',
	'category_id': 1,
	'product_title': '1亿像素,五摄四闪',
	'product_intro': '1亿像素主摄 / 全场景五摄像头 / 四闪光灯 / 3200万自拍 / 10 倍混合光学变焦，50倍数字变焦 / 5260mAh ⼤电量 / 标配 30W疾速快充 / ⼩米⾸款超薄屏下指纹 / 德国莱茵低蓝光认证 / 多功能NFC / 红外万能遥控 / 1216超线性扬声器',
	'product_picture': 'https://cdn.cnbj1.fds.api.mi-img.com/mi-mall/73617424da6ff6b64f9c630387bca874.jpg?thumb=1&w=400&h=400&f=webp&q=90',
	'product_price': 2799,
	'product_selling_price': 2599,
	'product_num': 20,
	'product_sales': 0,
}, {
	'product_id': 4,
	'product_name': 'Redmi 8',
	'category_id': 1,
	'product_title': '5000mAh超长续航',
	'product_intro': '5000mAh超长续航 / 高通骁龙439八核处理器 / 4GB+64GB',
	'product_picture': 'https://cdn.cnbj1.fds.api.mi-img.com/mi-mall/5a260090e0e08770b0bd865845a4b4ab.jpg?thumb=1&w=400&h=400&f=webp&q=90',
	'product_price': 799,
	'product_selling_price': 699,
	'product_num': 20,
	'product_sales': 0,
}, {
	'product_id': 5,
	'product_name': 'Redmi 8A',
	'category_id': 1,
	'product_title': '5000mAh超长续航',
	'product_intro': '5000mAh超长续航 / 高通骁龙439八核处理器 / 4GB+64GB / 1200万AI后置相机',
	'product_picture': 'https://cdn.cnbj1.fds.api.mi-img.com/mi-mall/0099822e42b4428cb25c4cdebc6ca53d.jpg?thumb=1&w=400&h=400&f=webp&q=90',
	'product_price': 599,
	'product_selling_price': 699,
	'product_num': 20,
	'product_sales': 0,
}, {
	'product_id': 6,
	'product_name': 'Redmi Note8 Pro',
	'category_id': 1,
	'product_title': '6400万全场景四摄',
	'product_intro': '6400万四摄小金刚拍照新旗舰超强解析力，超震撼',
	'product_picture': 'https://cdn.cnbj1.fds.api.mi-img.com/mi-mall/13f10e47913f9dc82e6c6a6199f413cd.jpg?thumb=1&w=400&h=400&f=webp&q=90',
	'product_price': 1399,
	'product_selling_price': 1199,
	'product_num': 20,
	'product_sales': 0,
}, {
	'product_id': 7,
	'product_name': 'Redmi Note8',
	'category_id': 1,
	'product_title': '千元4800万四摄',
	'product_intro': '千元4800万四摄 | 高通骁龙665 | 小金刚品质保证',
	'product_picture': 'https://cdn.cnbj1.fds.api.mi-img.com/mi-mall/4e75e528fb468aee107f551179aa0799.jpg?thumb=1&w=400&h=400&f=webp&q=90',
	'product_price': 999,
	'product_selling_price': 999,
	'product_num': 20,
	'product_sales': 0,
}]

export const ProductData = [{
	title: '手机',
	product,
	bigPoster: 'https://cdn.cnbj1.fds.api.mi-img.com/mi-mall/431e5fd6bfd1b67d096928248be18303.jpg?thumb=1&w=2452&h=240&f=webp&q=90',
	actions: [{ title: '查看更多', product }],
	posters: [{
		img: 'https://cdn.cnbj1.fds.api.mi-img.com/mi-mall/cb1bd61ad71c45a4f67f09b075463944.jpeg?thumb=1&w=468&h=1228&f=webp&q=90',
		key: '1',
	}],
},
	{
		title: '家电',
		product,
		bigPoster: 'https://cdn.cnbj1.fds.api.mi-img.com/mi-mall/41d16e66381cfeda7b6b39ab67678d5e.jpg?thumb=1&w=2452&h=240&f=webp&q=90',
		actions: [{ title: '热门', product }, { title: '电视电影', product }],
		posters: [
			{
				img: 'https://cdn.cnbj1.fds.api.mi-img.com/mi-mall/116fc43816b87192be4e67cf762e8da5.jpeg?thumb=1&w=468&h=600&f=webp&q=90',
				key: '1',
			},
			{
				img: 'https://cdn.cnbj1.fds.api.mi-img.com/mi-mall/1e82177bd8c8cd140e0e582ecaa886dc.jpg?thumb=1&w=468&h=600&f=webp&q=90',
				key: '2',
			},
		],
	},
]
const products = [{
	'product_id': 1,
	'product_name': 'Redmi K30',
	'category_id': 1,
	'product_title': '120Hz流速屏，全速热爱',
	'product_intro': '120Hz高帧率流速屏/ 索尼6400万前后六摄 / 6.67\'小孔径全面屏 / 最高可选8GB+256GB大存储 / 高通骁龙730G处理器 / 3D四曲面玻璃机身 / 4500mAh+27W快充 / 多功能NFC',
	'product_picture': 'https://cdn.cnbj1.fds.api.mi-img.com/mi-mall/b3553083a4975325eab6470d94465548.jpg?thumb=1&w=400&h=400&f=webp&q=90',
	'product_price': 2000,
	'product_selling_price': 1599,
	'product_num': 10,
	'product_sales': 0,
}, {
	'product_id': 2,
	'product_name': 'Redmi K30 5G',
	'category_id': 1,
	'product_title': '双模5G,120Hz流速屏',
	'product_intro': '双模5G / 三路并发 / 高通骁龙765G / 7nm 5G低功耗处理器 / 120Hz高帧率流速屏 / 6.67\'小孔径全面屏 / 索尼6400万前后六摄 / 最高可选8GB+256GB大存储 / 4500mAh+30W快充 / 3D四曲面玻璃机身 / 多功能NFC',
	'product_picture': 'https://cdn.cnbj1.fds.api.mi-img.com/mi-mall/68217751d12b1bfd2f9766e458b5e2dd.jpg?thumb=1&w=400&h=400&f=webp&q=90',
	'product_price': 2599,
	'product_selling_price': 2599,
	'product_num': 10,
	'product_sales': 0,
}, {
	'product_id': 3,
	'product_name': '小米CC9 Pro',
	'category_id': 1,
	'product_title': '1亿像素,五摄四闪',
	'product_intro': '1亿像素主摄 / 全场景五摄像头 / 四闪光灯 / 3200万自拍 / 10 倍混合光学变焦，50倍数字变焦 / 5260mAh ⼤电量 / 标配 30W疾速快充 / ⼩米⾸款超薄屏下指纹 / 德国莱茵低蓝光认证 / 多功能NFC / 红外万能遥控 / 1216超线性扬声器',
	'product_picture': 'https://cdn.cnbj1.fds.api.mi-img.com/mi-mall/73617424da6ff6b64f9c630387bca874.jpg?thumb=1&w=400&h=400&f=webp&q=90',
	'product_price': 2799,
	'product_selling_price': 2599,
	'product_num': 20,
	'product_sales': 0,
}, {
	'product_id': 4,
	'product_name': 'Redmi 8',
	'category_id': 1,
	'product_title': '5000mAh超长续航',
	'product_intro': '5000mAh超长续航 / 高通骁龙439八核处理器 / 4GB+64GB',
	'product_picture': 'https://cdn.cnbj1.fds.api.mi-img.com/mi-mall/5a260090e0e08770b0bd865845a4b4ab.jpg?thumb=1&w=400&h=400&f=webp&q=90',
	'product_price': 799,
	'product_selling_price': 699,
	'product_num': 20,
	'product_sales': 0,
}, {
	'product_id': 5,
	'product_name': 'Redmi 8A',
	'category_id': 1,
	'product_title': '5000mAh超长续航',
	'product_intro': '5000mAh超长续航 / 高通骁龙439八核处理器 / 4GB+64GB / 1200万AI后置相机',
	'product_picture': 'https://cdn.cnbj1.fds.api.mi-img.com/mi-mall/0099822e42b4428cb25c4cdebc6ca53d.jpg?thumb=1&w=400&h=400&f=webp&q=90',
	'product_price': 599,
	'product_selling_price': 699,
	'product_num': 20,
	'product_sales': 0,
}, {
	'product_id': 6,
	'product_name': 'Redmi Note8 Pro',
	'category_id': 1,
	'product_title': '6400万全场景四摄',
	'product_intro': '6400万四摄小金刚拍照新旗舰超强解析力，超震撼',
	'product_picture': 'https://cdn.cnbj1.fds.api.mi-img.com/mi-mall/13f10e47913f9dc82e6c6a6199f413cd.jpg?thumb=1&w=400&h=400&f=webp&q=90',
	'product_price': 1399,
	'product_selling_price': 1199,
	'product_num': 20,
	'product_sales': 0,
}]


const headerProducts = [{
	'product_id': 1,
	'product_name': 'Redmi K30',
	'category_id': 1,
	'product_title': '120Hz流速屏，全速热爱',
	'product_intro': '120Hz高帧率流速屏/ 索尼6400万前后六摄 / 6.67\'小孔径全面屏 / 最高可选8GB+256GB大存储 / 高通骁龙730G处理器 / 3D四曲面玻璃机身 / 4500mAh+27W快充 / 多功能NFC',
	'product_picture': 'https://cdn.cnbj1.fds.api.mi-img.com/mi-mall/f9149ef3ba2c9025a4a21c98ae793808.png?thumb=1&w=320&h=220&f=webp&q=90',
	'product_price': 2000,
	'product_selling_price': 1599,
	'product_num': 10,
	'product_sales': 0,
}, {
	'product_id': 2,
	'product_name': 'Redmi K30 5G',
	'category_id': 1,
	'product_title': '双模5G,120Hz流速屏',
	'product_intro': '双模5G / 三路并发 / 高通骁龙765G / 7nm 5G低功耗处理器 / 120Hz高帧率流速屏 / 6.67\'小孔径全面屏 / 索尼6400万前后六摄 / 最高可选8GB+256GB大存储 / 4500mAh+30W快充 / 3D四曲面玻璃机身 / 多功能NFC',
	'product_picture': 'https://cdn.cnbj1.fds.api.mi-img.com/mi-mall/963679eaf3937351e154600ab3448460.png?thumb=1&w=320&h=220&f=webp&q=90',
	'product_price': 2599,
	'product_selling_price': 2599,
	'product_num': 10,
	'product_sales': 0,
}, {
	'product_id': 3,
	'product_name': '小米CC9 Pro',
	'category_id': 1,
	'product_title': '1亿像素,五摄四闪',
	'product_intro': '1亿像素主摄 / 全场景五摄像头 / 四闪光灯 / 3200万自拍 / 10 倍混合光学变焦，50倍数字变焦 / 5260mAh ⼤电量 / 标配 30W疾速快充 / ⼩米⾸款超薄屏下指纹 / 德国莱茵低蓝光认证 / 多功能NFC / 红外万能遥控 / 1216超线性扬声器',
	'product_picture': 'https://cdn.cnbj1.fds.api.mi-img.com/mi-mall/b11742a0be47f9d97bb6a13ea580018d.png?thumb=1&w=320&h=220&f=webp&q=90',
	'product_price': 2799,
	'product_selling_price': 2599,
	'product_num': 20,
	'product_sales': 0,
}, {
	'product_id': 4,
	'product_name': 'Redmi 8',
	'category_id': 1,
	'product_title': '5000mAh超长续航',
	'product_intro': '5000mAh超长续航 / 高通骁龙439八核处理器 / 4GB+64GB',
	'product_picture': 'https://cdn.cnbj1.fds.api.mi-img.com/mi-mall/a4a76ee684e51f0ee531ef3dc7f0aeaf.png?thumb=1&w=320&h=220&f=webp&q=90',
	'product_price': 799,
	'product_selling_price': 699,
	'product_num': 20,
	'product_sales': 0,
}, {
	'product_id': 5,
	'product_name': 'Redmi 8A',
	'category_id': 1,
	'product_title': '5000mAh超长续航',
	'product_intro': '5000mAh超长续航 / 高通骁龙439八核处理器 / 4GB+64GB / 1200万AI后置相机',
	'product_picture': 'https://cdn.cnbj1.fds.api.mi-img.com/mi-mall/3bf20f1df3f2e22c5b29ff07634f3c59.png?thumb=1&w=320&h=220&f=webp&q=90',
	'product_price': 599,
	'product_selling_price': 699,
	'product_num': 20,
	'product_sales': 0,
}, {
	'product_id': 6,
	'product_name': 'Redmi Note8 Pro',
	'category_id': 1,
	'product_title': '6400万全场景四摄',
	'product_intro': '6400万四摄小金刚拍照新旗舰超强解析力，超震撼',
	'product_picture': 'https://cdn.cnbj1.fds.api.mi-img.com/mi-mall/5d19da60f9f62eb2aa5dcdbd7df19f0f.png?thumb=1&w=320&h=220&f=webp&q=90',
	'product_price': 1399,
	'product_selling_price': 1199,
	'product_num': 20,
	'product_sales': 0,
}]


const headerProducts2 = [{
	'product_id': 1,
	'product_name': 'Redmi K30',
	'category_id': 1,
	'product_title': '120Hz流速屏，全速热爱',
	'product_intro': '120Hz高帧率流速屏/ 索尼6400万前后六摄 / 6.67\'小孔径全面屏 / 最高可选8GB+256GB大存储 / 高通骁龙730G处理器 / 3D四曲面玻璃机身 / 4500mAh+27W快充 / 多功能NFC',
	'product_picture': 'https://cdn.cnbj1.fds.api.mi-img.com/mi-mall/174a2f9256a44b98f9e08bbe30528329.png?thumb=1&w=320&h=220&f=webp&q=90',
	'product_price': 2000,
	'product_selling_price': 1599,
	'product_num': 10,
	'product_sales': 0,
}, {
	'product_id': 2,
	'product_name': 'Redmi K30 5G',
	'category_id': 1,
	'product_title': '双模5G,120Hz流速屏',
	'product_intro': '双模5G / 三路并发 / 高通骁龙765G / 7nm 5G低功耗处理器 / 120Hz高帧率流速屏 / 6.67\'小孔径全面屏 / 索尼6400万前后六摄 / 最高可选8GB+256GB大存储 / 4500mAh+30W快充 / 3D四曲面玻璃机身 / 多功能NFC',
	'product_picture': 'https://cdn.cnbj1.fds.api.mi-img.com/mi-mall/8c87fdc4bcfd081ac240f7af1417ce60.png?thumb=1&w=320&h=220&f=webp&q=90',
	'product_price': 2599,
	'product_selling_price': 2599,
	'product_num': 10,
	'product_sales': 0,
}, {
	'product_id': 3,
	'product_name': '小米CC9 Pro',
	'category_id': 1,
	'product_title': '1亿像素,五摄四闪',
	'product_intro': '1亿像素主摄 / 全场景五摄像头 / 四闪光灯 / 3200万自拍 / 10 倍混合光学变焦，50倍数字变焦 / 5260mAh ⼤电量 / 标配 30W疾速快充 / ⼩米⾸款超薄屏下指纹 / 德国莱茵低蓝光认证 / 多功能NFC / 红外万能遥控 / 1216超线性扬声器',
	'product_picture': 'https://cdn.cnbj1.fds.api.mi-img.com/mi-mall/e513ac03d0ebb594bf42f7d6b1b44944.png?thumb=1&w=320&h=220&f=webp&q=90',
	'product_price': 2799,
	'product_selling_price': 2599,
	'product_num': 20,
	'product_sales': 0,
}, {
	'product_id': 4,
	'product_name': 'Redmi 8',
	'category_id': 1,
	'product_title': '5000mAh超长续航',
	'product_intro': '5000mAh超长续航 / 高通骁龙439八核处理器 / 4GB+64GB',
	'product_picture': 'https://cdn.cnbj1.fds.api.mi-img.com/mi-mall/932b583c6eccd8aabfa0771f8a854940.jpg?thumb=1&w=320&h=220&f=webp&q=90',
	'product_price': 799,
	'product_selling_price': 699,
	'product_num': 20,
	'product_sales': 0,
}, {
	'product_id': 5,
	'product_name': 'Redmi 8A',
	'category_id': 1,
	'product_title': '5000mAh超长续航',
	'product_intro': '5000mAh超长续航 / 高通骁龙439八核处理器 / 4GB+64GB / 1200万AI后置相机',
	'product_picture': 'https://cdn.cnbj1.fds.api.mi-img.com/mi-mall/ea3390a20547c7298a258528e4aa69ad.png?thumb=1&w=320&h=220&f=webp&q=90',
	'product_price': 599,
	'product_selling_price': 699,
	'product_num': 20,
	'product_sales': 0,
}, {
	'product_id': 6,
	'product_name': 'Redmi Note8 Pro',
	'category_id': 1,
	'product_title': '6400万全场景四摄',
	'product_intro': '6400万四摄小金刚拍照新旗舰超强解析力，超震撼',
	'product_picture': 'https://cdn.cnbj1.fds.api.mi-img.com/mi-mall/0112cb7e2ea8489fbd36ce3a781d5232.jpg?thumb=1&w=320&h=220&f=webp&q=90',
	'product_price': 1399,
	'product_selling_price': 1199,
	'product_num': 20,
	'product_sales': 0,
}]

export const headerData = [{ title: '小米手机', products: headerProducts }, {
	title: '电视',
	products: headerProducts2,
}, { title: 'Redmi红米', products: headerProducts }, { title: '笔记本', products: headerProducts }, {
	title: '家电',
	products: headerProducts2,
}, { title: '路由器' }, { title: '智能硬件' }, { title: '服务' }, { title: '社区' }]

export const guides = ['小米商城', 'MIUI', 'IoT', '云服务', '天星数科', '有品', '小爱开发平台', '企业团购', '资质证照', '协议规则', '下载app', '只能生活', 'Select Location']
export const users = ['登录', '注册', '消息通知']

export const seckillList = [{
				'goods_id': '2192100039',
				'product_id': '9884',
				'goods_name': '米家护颈记忆绵枕 灰色',
				'desc': '高低曲线承托，睡眠更自在',
				'seckill_type': 'seckill',
				'goods_price': '99',
				'seckill_Price': '79',
				'discount_img': 'https://cdn.cnbj1.fds.api.mi-img.com/mi-mall/0f7daf198ff627a0ac107923ba16ddab.jpg',
				'img': 'https://cdn.cnbj1.fds.api.mi-img.com/mi-mall/0f7daf198ff627a0ac107923ba16ddab.jpg',
				'pc_img': 'https://cdn.cnbj1.fds.api.mi-img.com/mi-mall/ef7b6af7926b7b44da1343e144a8f801.png',
				'label_text': '',
				'is_test': '0',
				'action': { 'log_code': '31activity_homeseckill#goodsid=2192100039\u0026start_time=1616292000\u0026end_time=1616305320' },
			}, {
				'goods_id': '2201300013',
				'product_id': '11821',
				'goods_name': '小米真无线蓝牙耳机Air 2s 白色',
				'desc': '全面升级，智慧真无线',
				'seckill_type': 'seckill',
				'goods_price': '399',
				'seckill_Price': '369',
				'discount_img': 'https://cdn.cnbj1.fds.api.mi-img.com/mi-mall/94061f53962389dc8844bd9e5df1a1ae.jpg',
				'img': 'https://cdn.cnbj1.fds.api.mi-img.com/mi-mall/94061f53962389dc8844bd9e5df1a1ae.jpg',
				'pc_img': 'https://cdn.cnbj1.fds.api.mi-img.com/mi-mall/df4aa657a9d1e8f3c79364a9ea113b7a.png',
				'label_text': '',
				'is_test': '0',
				'action': { 'log_code': '31activity_homeseckill#goodsid=2201300013\u0026start_time=1616292000\u0026end_time=1616305320' },
			},
	{
				'goods_id': '2194500025',
				'product_id': '11222',
				'goods_name': '智能积木 公路赛车 白色',
				'desc': '烧脑搭建，尽兴狂奔',
				'seckill_type': 'seckill',
				'goods_price': '299',
				'seckill_Price': '269',
				'discount_img': 'https://cdn.cnbj1.fds.api.mi-img.com/mi-mall/b464671ac030e3da494b279bac705b63.jpg',
				'img': 'https://cdn.cnbj1.fds.api.mi-img.com/mi-mall/b464671ac030e3da494b279bac705b63.jpg',
				'pc_img': 'https://cdn.cnbj1.fds.api.mi-img.com/mi-mall/0b5665bc7612ccaea133d1e8311bf422.png',
				'label_text': '',
				'is_test': '0',
				'action': { 'log_code': '31activity_homeseckill#goodsid=2194500025\u0026start_time=1616292000\u0026end_time=1616305320' },
			}, {
				'goods_id': '2201700006',
				'product_id': '11943',
				'goods_name': '米家扫拖机器人G1 白色',
				'desc': '能扫会拖，整屋清洁一步到位',
				'seckill_type': 'seckill',
				'goods_price': '999',
				'seckill_Price': '899',
				'discount_img': 'https://cdn.cnbj1.fds.api.mi-img.com/mi-mall/a0b76cf97563d009fc8d4b331e2e16fb.jpg',
				'img': 'https://cdn.cnbj1.fds.api.mi-img.com/mi-mall/a0b76cf97563d009fc8d4b331e2e16fb.jpg',
				'pc_img': 'https://cdn.cnbj1.fds.api.mi-img.com/mi-mall/f9b7f04730f4f475b58c2762f195378a.png',
				'label_text': '',
				'is_test': '0',
				'action': { 'log_code': '31activity_homeseckill#goodsid=2201700006\u0026start_time=1616292000\u0026end_time=1616305320' },
			},
	{
				'goods_id': '2202300015',
				'product_id': '12261',
				'goods_name': '米家声波电动牙刷T500C 蓝色',
				'desc': '智能护齿，个性定制洁齿方案',
				'seckill_type': 'seckill',
				'goods_price': '269',
				'seckill_Price': '249',
				'discount_img': 'https://cdn.cnbj1.fds.api.mi-img.com/mi-mall/67058a868c73c56af28c6fd5fd4ca1d3.jpg',
				'img': 'https://cdn.cnbj1.fds.api.mi-img.com/mi-mall/67058a868c73c56af28c6fd5fd4ca1d3.jpg',
				'pc_img': 'https://cdn.cnbj1.fds.api.mi-img.com/mi-mall/b81ea9623738be4a58c3ed41321718cc.png',
				'label_text': '',
				'is_test': '0',
				'action': { 'log_code': '31activity_homeseckill#goodsid=2202300015\u0026start_time=1616292000\u0026end_time=1616305320' },
			}, {
				'goods_id': '2192400020',
				'product_id': '10085',
				'goods_name': '九号平衡车 改装套件 白色',
				'desc': '小朋友的大玩具，老顽童的小赛车',
				'seckill_type': 'seckill',
				'goods_price': '2999',
				'seckill_Price': '2799',
				'discount_img': 'https://cdn.cnbj1.fds.api.mi-img.com/mi-mall/269a513f72fa04e4a83707fe73b8b46a.jpg',
				'img': 'https://cdn.cnbj1.fds.api.mi-img.com/mi-mall/269a513f72fa04e4a83707fe73b8b46a.jpg',
				'pc_img': 'https://cdn.cnbj1.fds.api.mi-img.com/mi-mall/0a3d70b9852a9ad20c5b0d78fbe8671d.png',
				'label_text': '',
				'is_test': '0',
				'action': { 'log_code': '31activity_homeseckill#goodsid=2192400020\u0026start_time=1616292000\u0026end_time=1616305320' },
			}, {
				'goods_id': '2200700011',
				'product_id': '11605',
				'goods_name': '小米手表 尊享版 曜石黑',
				'desc': ' 能打电话、能下载APP，才是真正的智能手表',
				'seckill_type': 'seckill',
				'goods_price': '1999',
				'seckill_Price': '1499',
				'discount_img': 'https://cdn.cnbj1.fds.api.mi-img.com/mi-mall/3e54812eefabd08553740af6c31bc6b7.jpg',
				'img': 'https://cdn.cnbj1.fds.api.mi-img.com/mi-mall/3e54812eefabd08553740af6c31bc6b7.jpg',
				'pc_img': 'https://cdn.cnbj1.fds.api.mi-img.com/mi-mall/6cc07289d1a7d050d24e3fedf1f73086.png',
				'label_text': '',
				'is_test': '0',
				'action': { 'log_code': '31activity_homeseckill#goodsid=2200700011\u0026start_time=1616292000\u0026end_time=1616305320' },
			}, {
				'goods_id': '2203300004',
				'product_id': '9850',
				'goods_name': '小米智能门锁 霸王锁体 碳素黑',
				'desc': '一体化活体指纹识别，多种开锁方式',
				'seckill_type': 'seckill',
				'goods_price': '1599',
				'seckill_Price': '1399',
				'discount_img': 'https://cdn.cnbj1.fds.api.mi-img.com/mi-mall/b1191cc4bf08bb5fe7a1822008a67427.jpg',
				'img': 'https://cdn.cnbj1.fds.api.mi-img.com/mi-mall/b1191cc4bf08bb5fe7a1822008a67427.jpg',
				'pc_img': 'https://cdn.cnbj1.fds.api.mi-img.com/mi-mall/942683830fe83028d3cc1f15a70a3e7d.png',
				'label_text': '',
				'is_test': '0',
				'action': { 'log_code': '31activity_homeseckill#goodsid=2203300004\u0026start_time=1616292000\u0026end_time=1616305320' },
			}, {
				'goods_id': '2200300009',
				'product_id': '11538',
				'goods_name': '米家手自一体电动螺丝刀 黑色',
				'desc': '小巧有力，得心应手',
				'seckill_type': 'seckill',
				'goods_price': '149',
				'seckill_Price': '129',
				'discount_img': 'https://cdn.cnbj1.fds.api.mi-img.com/mi-mall/2fa0ef87c5af799501c80368a9d97b08.jpg',
				'img': 'https://cdn.cnbj1.fds.api.mi-img.com/mi-mall/2fa0ef87c5af799501c80368a9d97b08.jpg',
				'pc_img': 'https://cdn.cnbj1.fds.api.mi-img.com/mi-mall/6c47b4add4aa289e655b2673a0d01bee.png',
				'label_text': '',
				'is_test': '0',
				'action': { 'log_code': '31activity_homeseckill#goodsid=2200300009\u0026start_time=1616292000\u0026end_time=1616305320' },
			}, {
				'goods_id': '2202600001',
				'product_id': '12404',
				'goods_name': '米兔儿童电话手表4C 蓝色',
				'desc': '能视频通话的4G电话手表',
				'seckill_type': 'seckill',
				'goods_price': '399',
				'seckill_Price': '349',
				'discount_img': 'https://cdn.cnbj1.fds.api.mi-img.com/mi-mall/3f57940962999e311abbddba7ec13300.jpg',
				'img': 'https://cdn.cnbj1.fds.api.mi-img.com/mi-mall/3f57940962999e311abbddba7ec13300.jpg',
				'pc_img': 'https://cdn.cnbj1.fds.api.mi-img.com/mi-mall/b942792b6d1edc16d2fb2cb317dc60a9.png',
				'label_text': '',
				'is_test': '0',
				'action': { 'log_code': '31activity_homeseckill#goodsid=2202600001\u0026start_time=1616292000\u0026end_time=1616305320' },
			}, {
				'goods_id': '2201600013',
				'product_id': '11916',
				'goods_name': '小米米家电动滑板车1S 黑色',
				'desc': '型出格，行出色',
				'seckill_type': 'seckill',
				'goods_price': '1999',
				'seckill_Price': '1799',
				'discount_img': 'https://cdn.cnbj1.fds.api.mi-img.com/mi-mall/5460f04ef20b51887170c8fd50d1a8aa.jpg',
				'img': 'https://cdn.cnbj1.fds.api.mi-img.com/mi-mall/5460f04ef20b51887170c8fd50d1a8aa.jpg',
				'pc_img': 'https://cdn.cnbj1.fds.api.mi-img.com/mi-mall/c817c5e45ee33613cb94b3d66e0ec657.png',
				'label_text': '',
				'is_test': '0',
				'action': { 'log_code': '31activity_homeseckill#goodsid=2201600013\u0026start_time=1616292000\u0026end_time=1616305320' },
			}, {
				'goods_id': '2191200015',
				'product_id': '9527',
				'goods_name': '米家扫地机器人1S 白色',
				'desc': '看得明白扫得彻底',
				'seckill_type': 'seckill',
				'goods_price': '1999',
				'seckill_Price': '1699',
				'discount_img': 'https://cdn.cnbj1.fds.api.mi-img.com/mi-mall/7ab4f0066d741443b58d5b47e2e5b72c.jpg',
				'img': 'https://cdn.cnbj1.fds.api.mi-img.com/mi-mall/7ab4f0066d741443b58d5b47e2e5b72c.jpg',
				'pc_img': 'https://cdn.cnbj1.fds.api.mi-img.com/mi-mall/f8dfb1af5a437b65bcc9108b82411265.png',
				'label_text': '',
				'is_test': '0',
				'action': { 'log_code': '31activity_homeseckill#goodsid=2191200015\u0026start_time=1616292000\u0026end_time=1616305320' },
			},
	{
				'goods_id': '2203700003',
				'product_id': '12774',
				'goods_name': '纯麦无线K歌麦克风 U7PRO',
				'desc': '小米电视专属定制，全场景麦克风',
				'seckill_type': 'seckill',
				'goods_price': '399',
				'seckill_Price': '359',
				'discount_img': 'https://cdn.cnbj1.fds.api.mi-img.com/mi-mall/a4452ef4a83ea591e14c38ccc1f7b99b.jpg',
				'img': 'https://cdn.cnbj1.fds.api.mi-img.com/mi-mall/a4452ef4a83ea591e14c38ccc1f7b99b.jpg',
				'pc_img': 'https://cdn.cnbj1.fds.api.mi-img.com/mi-mall/3b76c32a6b8beb73d00e22d7199bcba8.png',
				'label_text': '',
				'is_test': '0',
				'action': { 'log_code': '31activity_homeseckill#goodsid=2203700003\u0026start_time=1616292000\u0026end_time=1616305320' },
			}, {
				'goods_id': '2194100059',
				'product_id': '10999',
				'goods_name': '脊安适 颈部按摩器 护颈仪G2',
				'desc': '恒温热敷 米家APP操控 3大按摩手法',
				'seckill_type': 'seckill',
				'goods_price': '399',
				'seckill_Price': '279',
				'discount_img': 'https://cdn.cnbj1.fds.api.mi-img.com/mi-mall/aa10314c1a35854254b0c96f10ae758b.jpg',
				'img': 'https://cdn.cnbj1.fds.api.mi-img.com/mi-mall/aa10314c1a35854254b0c96f10ae758b.jpg',
				'pc_img': 'https://cdn.cnbj1.fds.api.mi-img.com/mi-mall/b7f3ac0cb8b15834692b1d10af134c33.png',
				'label_text': '',
				'is_test': '0',
				'action': { 'log_code': '31activity_homeseckill#goodsid=2194100059\u0026start_time=1616292000\u0026end_time=1616305320' },
			},{
		'goods_id': '2194500025',
		'product_id': '11222',
		'goods_name': '智能积木 公路赛车 白色',
		'desc': '烧脑搭建，尽兴狂奔',
		'seckill_type': 'seckill',
		'goods_price': '299',
		'seckill_Price': '269',
		'discount_img': 'https://cdn.cnbj1.fds.api.mi-img.com/mi-mall/b464671ac030e3da494b279bac705b63.jpg',
		'img': 'https://cdn.cnbj1.fds.api.mi-img.com/mi-mall/b464671ac030e3da494b279bac705b63.jpg',
		'pc_img': 'https://cdn.cnbj1.fds.api.mi-img.com/mi-mall/0b5665bc7612ccaea133d1e8311bf422.png',
		'label_text': '',
		'is_test': '0',
		'action': { 'log_code': '31activity_homeseckill#goodsid=2194500025\u0026start_time=1616292000\u0026end_time=1616305320' },
	}, {
		'goods_id': '2201700006',
		'product_id': '11943',
		'goods_name': '米家扫拖机器人G1 白色',
		'desc': '能扫会拖，整屋清洁一步到位',
		'seckill_type': 'seckill',
		'goods_price': '999',
		'seckill_Price': '899',
		'discount_img': 'https://cdn.cnbj1.fds.api.mi-img.com/mi-mall/a0b76cf97563d009fc8d4b331e2e16fb.jpg',
		'img': 'https://cdn.cnbj1.fds.api.mi-img.com/mi-mall/a0b76cf97563d009fc8d4b331e2e16fb.jpg',
		'pc_img': 'https://cdn.cnbj1.fds.api.mi-img.com/mi-mall/f9b7f04730f4f475b58c2762f195378a.png',
		'label_text': '',
		'is_test': '0',
		'action': { 'log_code': '31activity_homeseckill#goodsid=2201700006\u0026start_time=1616292000\u0026end_time=1616305320' },
	}]
export const seckillResult=chunk(seckillList,4)

export const borderColors=['red','green','black','yellow','blue','pink']
